import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesLinkTypesActivateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-linktypes-activate',
	path: '/secure/admin/IssueLinkingActivate.jspa',
};
